/**
 * Einstieg Newsletter-Anmeldung (Startseite 13 + Übersetzungen; eingebunden über plantclue-core includes/forms/forms.php).
 */
import { initNewsletterForm } from '../components/forms/newsletter-form.js';

initNewsletterForm();
